import Vue from "vue"
import VueRouter from "vue-router"

import settingsRoutes from "./settings/"
import gekkoRoutes from "./gekko/"

Vue.use(VueRouter)

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === 'production' ? './' : './', //process.env.BASE_URL
  routes: [
    ...settingsRoutes,
    ...gekkoRoutes
  ]
})

export default router
